import React, { useContext } from 'react';
import SvgIcon from "../../../../../common/components/svg-icon";
import HeaderLinks from '../../../../common/components/header-links';
import { BaseContext } from '../contexts';

const Filters = ({ show, onChange, filters, sort, loading }) => {
  const { verizonRoles } = useContext(BaseContext);

  const onFilterClick = () => {
    onChange(!show);
  };

  const reports = [
    {
      title: 'Database Report',
      name: 'vcc2024_database_report',
      kinds: [ 'google' ],
      kindTitles: [ 'Google Sheets' ]
    }
  ];

  if (verizonRoles.length) {
    reports[0]['pageEvent'] = { kind: 'export_database', page: 'database', caseIds: [] };
  }

  return (
    <div className="projects_controls-grid">
      <div className="projects_controls-grid-item">
        <button
          className="button -bordered-white"
          onClick={ onFilterClick }
        >
          <SvgIcon className="icon-link_icon" name="i-sliders" />
          <span className="icon-link_text">Filter</span>
        </button>
      </div>
      <div className="projects_controls-grid-item">
        <HeaderLinks
          reports={ reports }
          filter={ JSON.stringify(filters) }
          sort={ JSON.stringify(sort) }
          loading={ loading }
        />
      </div>
    </div>
  );
};

export default Filters;
